<template>
    <div>
        <loading-custom :loading="loading" />
        <div
            class="modal"
            :id="`editData` + body_id"
            tabindex="-1"
            role="dialog"
        >
            <div class="modal-dialog modal-lg" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        แก้ไขข้อมูล
                        <button
                            type="button"
                            class="close"
                            data-dismiss="modal"
                            aria-label="Close"
                        >
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>

                    <div class="modal-body">
                        <div class="text-left col-lg-6 col-md-12 p-0">
                            <label>เลือกประเภทข้อมูล</label>
                            <div class="c_multiselect">
                                <select
                                    v-model="dataType"
                                    id="single-selection"
                                    name="single_selection"
                                    class=" form-control multiselect multiselect-custom"
                                    @change="changeType()"
                                >
                                    <option value="" disabled
                                        >---- เลือกประเภทข้อมูล ----</option
                                    >
                                    <option value="text">ข้อความ</option>
                                    <option value="image">รูปภาพ</option>
                                    <option value="video">วีดีโอ</option>
                                    <option value="button"
                                        >call to action</option
                                    >
                                </select>
                            </div>
                        </div>

                        <!----- Text input ----->
                        <div
                            v-show="dataType === 'text'"
                            class="text-left col-lg-12 my-3 p-0"
                        >
                            <div class="card mb-0">
                                <div class="card-body p-0">
                                    <label>กล่องข้อความ</label>
                                    <trumbowyg
                                        v-model="bodyValue"
                                        :config="config"
                                        svgPath="/vendor/trumbowyg/dist/ui/icons.svg"
                                    ></trumbowyg>
                                </div>
                            </div>
                        </div>

                        <!----- Image input ----->
                        <div
                            v-if="dataType === 'image'"
                            class="text-left col-lg-12 my-3 p-0"
                        >
                            <div class="card mb-0">
                                <div class="card-body p-0">
                                    <div class="media">
                                        <div
                                            class="media-left m-r-20"
                                            v-if="imageSrc"
                                        >
                                            <img
                                                :src="imageSrc"
                                                class="user-photo media-object"
                                                alt="User"
                                            />
                                        </div>
                                        <div class="media-body">
                                            <label class="col-12 p-0"
                                                >เพิ่มรูปภาพ</label
                                            >
                                            <div
                                                class="tw-text-xs tw-text-gray-500 col-12 mb-2 p-0"
                                            >
                                                <span
                                                    >Recommended : 1920x1080
                                                    pixels, 1280x720 pixels,
                                                    1080x1080 pixels</span
                                                >
                                            </div>
                                            <button
                                                type="button"
                                                class="btn btn-default"
                                                id="btn-upload-photo"
                                                @click="uploadImage"
                                            >
                                                อัพโหลด
                                            </button>
                                            <input
                                                type="file"
                                                :id="`filePhoto_${body_id}`"
                                                class="sr-only"
                                                @change="onFileChange"
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!----- Video input ----->
                        <div
                            v-else-if="dataType === 'video'"
                            class="text-left col-lg-12 my-3 p-0"
                        >
                            <div class="card mb-0">
                                <div class="card-body p-0">
                                    <label>เพิ่ม URL วิดีโอ</label>
                                    <input
                                        v-model="bodyValue"
                                        type="text"
                                        name="video"
                                        class="form-control"
                                        placeholder="URL"
                                    />
                                </div>
                            </div>
                        </div>

                        <!----- Button input ----->
                        <div
                            v-else-if="dataType === 'button'"
                            class="text-left col-lg-12 my-3 p-0"
                        >
                            <div class="card mb-0">
                                <div class="card-body p-0">
                                    <div class="media">
                                        <div
                                            class="media-left m-r-20"
                                            v-if="imageSrc"
                                        >
                                            <img
                                                :src="imageSrc"
                                                class="user-photo media-object"
                                                alt="User"
                                            />
                                        </div>
                                        <div class="media-body">
                                            <label class="col-12 p-0"
                                                >เพิ่มรูปภาพ</label
                                            >
                                            <div
                                                class="tw-text-xs tw-text-gray-500 col-12 mb-2 p-0"
                                            >
                                                <span
                                                    >Recommended : 1920x1080
                                                    pixels, 1280x720
                                                    pixels</span
                                                >
                                            </div>
                                            <button
                                                type="button"
                                                class="btn btn-default"
                                                id="btn-upload-photo"
                                                @click="uploadImage"
                                            >
                                                อัพโหลด
                                            </button>
                                            <input
                                                type="file"
                                                :id="`filePhoto_${body_id}`"
                                                class="sr-only"
                                                @change="onFileChange"
                                            />
                                        </div>
                                    </div>
                                    <label>เพิ่ม URL</label>
                                    <input
                                        v-model="bodyValue"
                                        type="text"
                                        name="video"
                                        class="form-control"
                                        placeholder="URL"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <button
                            type="button"
                            class="btn btn-sm btn-default"
                            data-dismiss="modal"
                        >
                            ยกเลิก
                        </button>
                        <button
                            type="button"
                            class="btn btn-sm btn-success"
                            data-dismiss="modal"
                            @click="update"
                        >
                            แก้ไข
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style lang="scss" scoped>
.btn-custom {
    height: 100%;
    @media (min-width: 0px) and (max-width: 992px) {
        margin-top: 20px;
        justify-content: center;
    }
    &__item {
        flex: 1;
        margin: 0 2px;
    }
}
.media {
    @media (min-width: 0px) and (max-width: 992px) {
        width: 100%;
        flex-flow: column;
        flex-direction: column-reverse;
    }
}
.media-left {
    img {
        width: 100%;
        max-width: 200px;
        max-height: 200px;
    }
    @media (min-width: 0px) and (max-width: 992px) {
        margin-top: 20px;
    }
}
</style>

<script>
import EditorTrumbowyg from "../../helper/EditorTrumbowyg.vue";
import DatePicker from "../DatePicker.vue";
import configTextEditor from "./_config_texteditor.js";

export default {
    components: { DatePicker, EditorTrumbowyg },
    props: {
        shop: {
            required: true,
            type: String
        },
        index: {
            require: true,
            type: Number
        },
        body_id: {
            require: true,
            type: Number
        },
        body: {
            require: true,
            type: Object
        },
        salepage: {
            require: true,
            type: Object
        }
    },
    data() {
        return {
            loading: false,
            dataType: this.body?.type || "",
            bodyValue:
                this.body?.type == "text"
                    ? this.body?.body
                    : this.body?.type == "video"
                    ? this.body?.body
                    : this.body?.type == "button"
                    ? this.body?.url
                    : "",
            imageSrc:
                this.body?.type == "image"
                    ? this.body.image_url
                    : this.body?.type == "button"
                    ? this.body.image_url
                    : "",
            count: 0,
            image: null,
            imageDir: "/bodies",
            config: configTextEditor
        };
    },
    watch: {
        body(val) {
            this.setEdit();
        }
    },
    methods: {
        setEdit() {
            // console.log(this.body_id);
            (this.dataType = this.body?.type || ""),
                (this.bodyValue =
                    this.body?.type == "text"
                        ? this.body?.body
                        : this.body?.type == "video"
                        ? this.body?.body
                        : this.body?.type == "button"
                        ? this.body?.url
                        : "");
            this.imageSrc =
                this.body?.type == "image"
                    ? this.body.image_url
                    : this.body?.type == "button"
                    ? this.body.image_url
                    : "";
        },
        changeType() {
            this.bodyValue = "";
        },
        uploadImage() {
            document.getElementById(`filePhoto_${this.body_id}`).click();
        },
        onFileChange(e) {
            let files = e.target.files || e.dataTransfer.files;
            if (!files.length) {
                return;
            }
            const file_size = files[0].size / 1024 / 1024;
            const file_name = files[0].name;
            const re = /(\.jpg|\.jpeg|\.png)$/i;
            if (file_size > 2) {
                this.messageAlert(
                    "error",
                    "ขนาดภาพใหญ่ไปนะ",
                    "TwT ขอโทษนะ กรุณาใช้ภาพขนาดไม่เกิน 2mb"
                );
            } else if (!re.exec(file_name)) {
                this.messageAlert(
                    "error",
                    "ไฟล์นี้ใช้ไม่ได้นะ",
                    "TwT ขอโทษนะ กรุณาใช้รูปภาพประเภท jpg, jpeg, png"
                );
            } else {
                this.image = files[0];
                this.previewImage(files[0]);
            }
        },
        previewImage(file) {
            this.imageSrc = URL.createObjectURL(file);
        },
        messageAlert(type, title, text) {
            this.$swal({
                icon: type,
                title: title,
                text: text,
                showConfirmButton: true
            });
        },
        update() {
            this.loading = true;
            if (this.dataType === "text" || this.dataType === "video") {
                axios
                    .patch(
                        `/backend/s/${this.shop}/salepages/${this.salepage.id}/bodies/${this.body.id}`,
                        {
                            type: this.dataType,
                            value: this.bodyValue
                        }
                    )
                    .then(res => {
                        window.location.reload();
                    })
                    .catch(err => {});
            }
            if (this.dataType === "image") {
                if (this.image) {
                    let formData = new FormData();
                    formData.append("type", this.dataType);
                    formData.append("body", this.image ? this.image : "");
                    formData.append("_method", "PATCH");

                    axios
                        .post(
                            `/backend/s/${this.shop}/salepages/${this.salepage.id}/bodies/upload-image/${this.body.id}`,
                            formData,
                            {
                                headers: {
                                    "Content-Type": "multipart/form-data"
                                }
                            }
                        )
                        .then(res => {
                            window.location.reload();
                        })
                        .catch(err => {});
                } else {
                    this.loading = false;
                }
            }
            if (this.dataType === "button") {
                let formData = new FormData();
                formData.append("type", this.dataType);
                formData.append("body", this.image ? this.image : "");
                formData.append("url", this.bodyValue);
                formData.append("_method", "PATCH");

                axios
                    .post(
                        `/backend/s/${this.shop}/salepages/${this.salepage.id}/bodies/upload-call-to-action/${this.body.id}`,
                        formData,
                        {
                            headers: {
                                "Content-Type": "multipart/form-data"
                            }
                        }
                    )
                    .then(res => {
                        window.location.reload();
                    })
                    .catch(err => {});
            }
        }
    }
};
</script>
